import { render, staticRenderFns } from "./CommissionForm.vue?vue&type=template&id=63bd7cfe&"
import script from "./CommissionForm.vue?vue&type=script&lang=js&"
export * from "./CommissionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports